/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { App } from '../models/app';
import { AppLabInfo } from '../models/app-lab-info';
import { EditorLabInfo } from '../models/editor-lab-info';
import { Lab } from '../models/lab';
import { labControllerCreate } from '../fn/lab/lab-controller-create';
import { LabControllerCreate$Params } from '../fn/lab/lab-controller-create';
import { labControllerFindEditorLabList } from '../fn/lab/lab-controller-find-editor-lab-list';
import { LabControllerFindEditorLabList$Params } from '../fn/lab/lab-controller-find-editor-lab-list';
import { labControllerFindLab } from '../fn/lab/lab-controller-find-lab';
import { LabControllerFindLab$Params } from '../fn/lab/lab-controller-find-lab';
import { labControllerFindLabByLanguage } from '../fn/lab/lab-controller-find-lab-by-language';
import { LabControllerFindLabByLanguage$Params } from '../fn/lab/lab-controller-find-lab-by-language';
import { labControllerFindLabWithAccounts } from '../fn/lab/lab-controller-find-lab-with-accounts';
import { LabControllerFindLabWithAccounts$Params } from '../fn/lab/lab-controller-find-lab-with-accounts';
import { labControllerFindSupportedLabList } from '../fn/lab/lab-controller-find-supported-lab-list';
import { LabControllerFindSupportedLabList$Params } from '../fn/lab/lab-controller-find-supported-lab-list';
import { labControllerGetLabList } from '../fn/lab/lab-controller-get-lab-list';
import { LabControllerGetLabList$Params } from '../fn/lab/lab-controller-get-lab-list';
import { labControllerGetSupportedLanguages } from '../fn/lab/lab-controller-get-supported-languages';
import { LabControllerGetSupportedLanguages$Params } from '../fn/lab/lab-controller-get-supported-languages';
import { labControllerGetTwentelabs } from '../fn/lab/lab-controller-get-twentelabs';
import { LabControllerGetTwentelabs$Params } from '../fn/lab/lab-controller-get-twentelabs';
import { labControllerGetUsageCount } from '../fn/lab/lab-controller-get-usage-count';
import { LabControllerGetUsageCount$Params } from '../fn/lab/lab-controller-get-usage-count';
import { labControllerRemove } from '../fn/lab/lab-controller-remove';
import { LabControllerRemove$Params } from '../fn/lab/lab-controller-remove';
import { labControllerUpdate } from '../fn/lab/lab-controller-update';
import { LabControllerUpdate$Params } from '../fn/lab/lab-controller-update';
import { LabWithAccounts } from '../models/lab-with-accounts';

@Injectable({ providedIn: 'root' })
export class LabService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `labControllerGetLabList()` */
  static readonly LabControllerGetLabListPath = '/lab/list';

  /**
   * Get the list of all labs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerGetLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetLabList$Response(params?: LabControllerGetLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Lab>>> {
    const obs = labControllerGetLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all labs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerGetLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetLabList(params?: LabControllerGetLabList$Params, context?: HttpContext): Observable<Array<Lab>> {
    const resp = this.labControllerGetLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Lab>>): Array<Lab> => r.body)
    );
  }

  /** Path part for operation `labControllerGetTwentelabs()` */
  static readonly LabControllerGetTwentelabsPath = '/lab/twenteList';

  /**
   * Get the list of all twente labs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerGetTwentelabs()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetTwentelabs$Response(params?: LabControllerGetTwentelabs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Lab>>> {
    const obs = labControllerGetTwentelabs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all twente labs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerGetTwentelabs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetTwentelabs(params?: LabControllerGetTwentelabs$Params, context?: HttpContext): Observable<Array<Lab>> {
    const resp = this.labControllerGetTwentelabs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Lab>>): Array<Lab> => r.body)
    );
  }

  /** Path part for operation `labControllerFindEditorLabList()` */
  static readonly LabControllerFindEditorLabListPath = '/lab/editorList/{language}';

  /**
   * Get the list of all labs which can be added in the editor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerFindEditorLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindEditorLabList$Response(params: LabControllerFindEditorLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorLabInfo>>> {
    const obs = labControllerFindEditorLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all labs which can be added in the editor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerFindEditorLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindEditorLabList(params: LabControllerFindEditorLabList$Params, context?: HttpContext): Observable<Array<EditorLabInfo>> {
    const resp = this.labControllerFindEditorLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<EditorLabInfo>>): Array<EditorLabInfo> => r.body)
    );
  }

  /** Path part for operation `labControllerFindSupportedLabList()` */
  static readonly LabControllerFindSupportedLabListPath = '/lab/supportedList';

  /**
   * Get the list of supported labs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerFindSupportedLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindSupportedLabList$Response(params?: LabControllerFindSupportedLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLabInfo>>> {
    const obs = labControllerFindSupportedLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of supported labs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerFindSupportedLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindSupportedLabList(params?: LabControllerFindSupportedLabList$Params, context?: HttpContext): Observable<Array<AppLabInfo>> {
    const resp = this.labControllerFindSupportedLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AppLabInfo>>): Array<AppLabInfo> => r.body)
    );
  }

  /** Path part for operation `labControllerCreate()` */
  static readonly LabControllerCreatePath = '/lab';

  /**
   * Create an lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  labControllerCreate$Response(params: LabControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
    const obs = labControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create an lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  labControllerCreate(params: LabControllerCreate$Params, context?: HttpContext): Observable<Lab> {
    const resp = this.labControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lab>): Lab => r.body)
    );
  }

  /** Path part for operation `labControllerFindLabWithAccounts()` */
  static readonly LabControllerFindLabWithAccountsPath = '/lab/labWithAccounts/{labId}';

  /**
   * Get lab with accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerFindLabWithAccounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindLabWithAccounts$Response(params: LabControllerFindLabWithAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<LabWithAccounts>> {
    const obs = labControllerFindLabWithAccounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get lab with accounts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerFindLabWithAccounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindLabWithAccounts(params: LabControllerFindLabWithAccounts$Params, context?: HttpContext): Observable<LabWithAccounts> {
    const resp = this.labControllerFindLabWithAccounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LabWithAccounts>): LabWithAccounts => r.body)
    );
  }

  /** Path part for operation `labControllerFindLab()` */
  static readonly LabControllerFindLabPath = '/lab/{labId}';

  /**
   * Get an lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerFindLab()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindLab$Response(params: LabControllerFindLab$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
    const obs = labControllerFindLab(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerFindLab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindLab(params: LabControllerFindLab$Params, context?: HttpContext): Observable<Lab> {
    const resp = this.labControllerFindLab$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lab>): Lab => r.body)
    );
  }

  /** Path part for operation `labControllerRemove()` */
  static readonly LabControllerRemovePath = '/lab/{labId}';

  /**
   * deletes an lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerRemove$Response(params: LabControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
    const obs = labControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * deletes an lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerRemove(params: LabControllerRemove$Params, context?: HttpContext): Observable<App> {
    const resp = this.labControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<App>): App => r.body)
    );
  }

  /** Path part for operation `labControllerUpdate()` */
  static readonly LabControllerUpdatePath = '/lab/{labId}';

  /**
   * Update an lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  labControllerUpdate$Response(params: LabControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
    const obs = labControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  labControllerUpdate(params: LabControllerUpdate$Params, context?: HttpContext): Observable<Lab> {
    const resp = this.labControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lab>): Lab => r.body)
    );
  }

  /** Path part for operation `labControllerFindLabByLanguage()` */
  static readonly LabControllerFindLabByLanguagePath = '/lab/{labId}/language/{language}';

  /**
   * Get a lab by language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerFindLabByLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindLabByLanguage$Response(params: LabControllerFindLabByLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
    const obs = labControllerFindLabByLanguage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a lab by language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerFindLabByLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerFindLabByLanguage(params: LabControllerFindLabByLanguage$Params, context?: HttpContext): Observable<Lab> {
    const resp = this.labControllerFindLabByLanguage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lab>): Lab => r.body)
    );
  }

  /** Path part for operation `labControllerGetUsageCount()` */
  static readonly LabControllerGetUsageCountPath = '/lab/usageCount/{url}';

  /**
   * Get the number of lab usage with the given url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerGetUsageCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetUsageCount$Response(params: LabControllerGetUsageCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = labControllerGetUsageCount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the number of lab usage with the given url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerGetUsageCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetUsageCount(params: LabControllerGetUsageCount$Params, context?: HttpContext): Observable<number> {
    const resp = this.labControllerGetUsageCount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `labControllerGetSupportedLanguages()` */
  static readonly LabControllerGetSupportedLanguagesPath = '/lab/{labId}/supportedLanguages';

  /**
   * Get the supported languages by a lab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labControllerGetSupportedLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetSupportedLanguages$Response(params: LabControllerGetSupportedLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    const obs = labControllerGetSupportedLanguages(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the supported languages by a lab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labControllerGetSupportedLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labControllerGetSupportedLanguages(params: LabControllerGetSupportedLanguages$Params, context?: HttpContext): Observable<Array<string>> {
    const resp = this.labControllerGetSupportedLanguages$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
